import { Link } from 'react-router-dom';
import { comics, latestComicIds } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = latestComicIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">最近更新</h2>
            <p className="text-sm text-foreground-500">新鲜出炉的最新章节，追更党速来</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop>
          {latest.map((comic) => comic && (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-50 transition-colors cursor-pointer border border-background-200/70"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-100">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="font-label font-medium text-sm text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {comic.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-label">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-[11px] text-foreground-400">更新至 {comic.chapters} 话</span>
                  <span className="text-[11px] text-primary-600 font-label">{comic.updateTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/fantasy-adventure"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-label transition-colors cursor-pointer"
          >
            查看更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}